var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('page-header',{attrs:{"title":_vm.header.title,"add-button":_vm.header.addButton}}),_c('filters'),_c('inner-list',{attrs:{"loading":_vm.loading,"results":_vm.results,"pagination":_vm.pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }